import { newGuid, Guid } from "client_legacy/ndaw/guid";

const CLIENT_ID_SYMBOL = Symbol("client-id");

export type ObjectWithClientId<TObject extends {}> = TObject & {
	__hasClientId: true;
};

export function setClientId<TObject extends {}>(obj: TObject): ObjectWithClientId<TObject> {
	(obj as InternalObjectWithClientId<TObject>)[CLIENT_ID_SYMBOL] = newGuid();

	return obj as ObjectWithClientId<TObject>;
}

export function hasClientId<TObject extends {}>(obj: TObject): obj is ObjectWithClientId<TObject> {
	const potentialClientId: Guid | undefined = (obj as InternalObjectWithClientId<TObject>)[CLIENT_ID_SYMBOL];
	return typeof potentialClientId === "string" && potentialClientId !== "";
}

export function getClientId<TObject extends {}>(obj: ObjectWithClientId<TObject>): Guid {
	const result: Guid | undefined = (obj as InternalObjectWithClientId<TObject>)[CLIENT_ID_SYMBOL];
	if (!result) {
		throw new Error("Client id is not set on an Object with client id");
	}

	return result;
}

export function tryGetClientId<TObject extends {}>(obj: TObject): Guid | undefined {
	if (hasClientId(obj)) {
		return getClientId(obj);
	}

	return undefined;
}

export function setExistingClientId<TObject extends {}>(obj: TObject, clientId: Guid): ObjectWithClientId<TObject> {
	(obj as InternalObjectWithClientId<TObject>)[CLIENT_ID_SYMBOL] = clientId;

	return obj as ObjectWithClientId<TObject>;
}

type InternalObjectWithClientId<TObject extends {}> = TObject & { [CLIENT_ID_SYMBOL]?: Guid; };